module.exports = __webpack_public_path__ + "img/pic7.10cb0d24.png";